import { mergeListOfUsers } from '../../components/helper/Utils'
import {
  SET_SEARCH_KEY,
  CLEAR_SEARCH_KEY,
  SET_FILTER_COUNT,
  SET_FILTER_VALUES,
  FETCH_SEARCH_USER_ERROR,
  FETCH_SEARCH_USER_START,
  FETCH_SEARCH_USER_SUCCESS,
} from '../actions/ActionConstant'

export const initialState = {
  users: {
    data: [],
    loading: false,
    error: false,
    success: null,
    inputData: {},
    hasNext: false,
    page: 1,
    size: 16
  },
  filters: {
    key: '',
    filterValues: {
      key: '',
      city: '',
      state: '',
      gender: '',
      height: '',
      category: '',
      location: '',
      body_type: '',
      ethnicity: '',
      user_type: 'All'
    },
    filterCount: 0,
  },
}

const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SEARCH_USER_START:
      return {
        ...state,
        users: {
          ...state.users,
          inputData: action.data,
          loading: true,
          success: false,
          error: null,
        },
      }
    case FETCH_SEARCH_USER_SUCCESS:
      const currentData = state.users.data || []
      return {
        ...state,
        users: {
          ...state.users,
          data: action.data.current_page === 1 ? action.data.data : mergeListOfUsers(currentData, action.data.data || []),
          page: action.data.current_page,
          hasNext: action.data.next_page_url ? true : false,
          loading: false,
          success: true,
          error: null,
        },
      }
    case FETCH_SEARCH_USER_ERROR:
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
          success: false,
          error: action.error,
        },
      }
    case SET_SEARCH_KEY:
      return {
        ...state,
        filters: {
          ...state.filters,
          key: action.data,
        },
      }
    case CLEAR_SEARCH_KEY:
      return {
        ...state,
        filters: {
          ...state.filters,
          key: '',
        },
      }
    case SET_FILTER_COUNT:
      return {
        ...state,
        filters: {
          ...state.filters,
          filterCount: action.data,
        },
      }
    case SET_FILTER_VALUES:
      return {
        ...state,
        filters: {
          ...state.filters,
          filterValues: action.data,
        },
      }
    default:
      return state
  }
}

export default SearchReducer
